import EventEmitter from 'events';


class ZoneSelectorControlBase extends EventEmitter {
  // Subclasses must implement:
  // collectZoneIds() { return [] }
  // selectZone(zoneId) { }
  // destroy() { }

  notifyZoneChange(zoneId) {
    this.emit('change', zoneId);
  }
}


class ZoneSelectList extends ZoneSelectorControlBase {
  /**
   * @param {HTMLSelectElement} select
   */
  constructor(select) {
    super();
    this.select = select;
    this.onSelectChange = this.onSelectChange.bind(this);

    this.select.addEventListener('change', this.onSelectChange);
  }

  onSelectChange() {
    const value = this.select.value;
    let zoneId;

    if (value === '') {
      zoneId = null;
    } else {
      zoneId = value;
    }

    this.notifyZoneChange(zoneId);
  }

  collectZoneIds() {
    return Array.from(this.select.options)
      .reduce((collection, el) => {
        const value = el.value;

        if (!el.disabled && value !== '') {
          collection.push(value);
        }

        return collection;
      }, []);
  }

  selectZone(zoneId) {
    if (zoneId === null) {
      this.select.selectedIndex = 0;
    } else {
      this.select.value = zoneId;
    }
  }

  destroy() {
    this.removeAllListeners();
    this.select.removeEventListener('change', this.onSelectChange);
  }
}


class ZoneRadioButtonList extends ZoneSelectorControlBase {
  /**
   * @param {HTMLInputElement[]} radios
   */
  constructor(radios) {
    super();

    /** @type {Map<string, HTMLInputElement>} */
    this.radiosByZoneId = new Map();

    this.onInputChange = this.onInputChange.bind(this);

    radios.forEach((radio) => {
      if (radio.disabled) {
        return;
      }

      const zoneId = radio.value;

      this.radiosByZoneId.set(zoneId, radio);

      radio.addEventListener('change', this.onInputChange);
    });
  }

  onInputChange(event) {
    const zoneId = event.target.value;
    this.notifyZoneChange(zoneId);
  }

  collectZoneIds() {
    return Array.from(this.radiosByZoneId.keys());
  }

  selectZone(zoneId) {
    const radio = this.radiosByZoneId.get(zoneId);
    radio.checked = true;
  }

  destroy() {
    this.removeAllListeners();
    this.radiosByZoneId.forEach((radio) => {
      radio.removeEventListener('change', this.onInputChange);
    });
  }
}


export { ZoneSelectList, ZoneRadioButtonList };



// WEBPACK FOOTER //
// ./V7/events/detail/ZoneSelectorControls.js